export function formatNumber(number: number, locale: string = 'ko-KR'): string {
  const result = number.toLocaleString([locale, 'en-US'])

  if (locale.includes('es')) {
    return result.replaceAll('.', ' ')
  }

  return result
}
